import { NgModule } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CardModule } from "primeng/card";
import { TableModule } from "primeng/table";
import { MultiSelectModule } from "primeng/multiselect";
import { TooltipModule } from "primeng/tooltip";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ListboxModule } from "primeng/listbox";
import { MessageModule } from "primeng/message";
import { MessagesModule } from "primeng/messages";
import { MessageService } from "primeng/api";
import { DialogModule } from "primeng/dialog";
import { ToastModule } from "primeng/toast";

@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    CardModule,
    DialogModule,
    DropdownModule,
    ListboxModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    TableModule,
    ToastModule,
    TooltipModule,
  ],
  exports: [
    ButtonModule,
    CardModule,
    DialogModule,
    DropdownModule,
    ListboxModule,
    MultiSelectModule,
    MessageModule,
    MessagesModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    TableModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [
    MessageService,
  ]
})
export class PrimengModule
{
  constructor() { }
}
